import { useState } from "react";
import { gold, w } from "../constants";
import { GIFTS, GIFT_CATEGORIES } from "../data/spiritualGifts";
import { Card } from "../components";
import { initPdf, downloadExcel } from "./exportHelpers";
function DownloadModal({ onPdf, onExcel, onClose }) {
  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000 }}>
      <div style={{ background:"#fff",borderRadius:16,padding:28,width:"100%",maxWidth:360,margin:"0 16px" }}>
        <h2 style={{ fontSize:17,fontWeight:500,margin:"0 0 6px",color:"#1a1a1a" }}>Download your results</h2>
        <p style={{ fontSize:13,color:"#555",margin:"0 0 20px" }}>Choose your preferred format:</p>
        <button onClick={onPdf} style={{ width:"100%",padding:"12px",borderRadius:10,border:"none",background:"#A0845C",color:"#fff",fontSize:14,fontWeight:500,cursor:"pointer",marginBottom:10 }}>📄 Download PDF</button>
        <button onClick={onExcel} style={{ width:"100%",padding:"12px",borderRadius:10,border:"0.5px solid rgba(0,0,0,0.1)",background:"transparent",color:"#1a1a1a",fontSize:14,cursor:"pointer",marginBottom:10 }}>📊 Download Excel</button>
        <button onClick={onClose} style={{ width:"100%",padding:"10px",borderRadius:10,border:"0.5px solid rgba(0,0,0,0.1)",background:"transparent",color:"#555",fontSize:13,cursor:"pointer" }}>Cancel</button>
      </div>
    </div>
  );
}

const LABELS = ["Never","Rarely","Sometimes","Often","Always"];
const MAX_SCORE = 25;

function scoreColor(pct) {
  if(pct>=70) return "#057A55";
  if(pct>=40) return "#D97706";
  return "#999";
}

function exportPdf(attempt, userName) {
  const sorted = [...GIFTS].map(g=>({...g,score:attempt.scores[g.id]||0,pct:Math.round(((attempt.scores[g.id]||0)/MAX_SCORE)*100)})).sort((a,b)=>b.score-a.score);
  const p = initPdf();
  p.addHeader("Spiritual Gifts Assessment", userName);
  p.heading1("Your Top 3 Gifts");
  sorted.slice(0,3).forEach((g,i)=>{
    p.heading2(`#${i+1} ${g.name} — ${g.score}/${MAX_SCORE} (${g.pct}%)`);
    p.body(g.description, 4);
    p.body(`Ministry roles: ${g.ministryRoles.join(", ")}`, 4);
    p.body(`How to grow: ${g.howToGrow}`, 4);
    p.body(g.ref, 4);
    p.space(4);
  });
  p.divider();
  p.heading1("Full Ranked List");
  GIFT_CATEGORIES.forEach(cat=>{
    p.heading3(cat);
    sorted.filter(g=>g.category===cat).forEach(g=>{
      p.checkY(8);
      const doc=p.doc; const margin=p.margin;
      doc.setFont("helvetica","normal");doc.setFontSize(10);doc.setTextColor(26,26,26);
      const yNow=p.y(); doc.text(`${g.name}`,margin,yNow);
      doc.text(`${g.score}/${MAX_SCORE}`,margin+120,yNow,{align:"right"});
      p.setY(yNow+6);
    });
    p.space(4);
  });
  p.addFooters();
  p.doc.save(`spiritual-gifts-${new Date().toISOString().slice(0,10)}.pdf`);
}

function exportExcel(attempt, userName) {
  const sorted = [...GIFTS].map(g=>({...g,score:attempt.scores[g.id]||0,pct:Math.round(((attempt.scores[g.id]||0)/MAX_SCORE)*100)})).sort((a,b)=>b.score-a.score);
  const date = new Date(attempt.date).toLocaleDateString("en-IN");
  const data = [
    ["My Self-Management Framework — Spiritual Gifts Assessment"],
    [`Name: ${userName}`, `Date: ${date}`],
    [],
    ["Rank","Gift","Category","Score","Out of","Percentage","Description"],
    ...sorted.map((g,i)=>[i+1,g.name,g.category,g.score,MAX_SCORE,`${g.pct}%`,g.description]),
  ];
  downloadExcel([{name:"Spiritual Gifts",data}], `spiritual-gifts-${new Date().toISOString().slice(0,10)}.xlsx`);
}

function ResultsView({ attempt, userName, onRetake, onBack }) {
  const [expanded, setExpanded] = useState(null);
  const [showDownload, setShowDownload] = useState(false);
  const sorted = [...GIFTS].map(g=>({...g,score:attempt.scores[g.id]||0,pct:Math.round(((attempt.scores[g.id]||0)/MAX_SCORE)*100)})).sort((a,b)=>b.score-a.score);

  return (
    <div>
      {showDownload&&<DownloadModal onPdf={()=>{exportPdf(attempt,userName);setShowDownload(false);}} onExcel={()=>{exportExcel(attempt,userName);setShowDownload(false);}} onClose={()=>setShowDownload(false)} />}
      <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",marginBottom:16,padding:0 }}>← Back to Modules</button>
      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:18,fontWeight:500,margin:"0 0 4px",color:w.text }}>Your Spiritual Gifts Results</h2>
          <p style={{ fontSize:13,color:w.text3,margin:0 }}>{new Date(attempt.date).toLocaleDateString("en-IN",{day:"numeric",month:"long",year:"numeric"})}</p>
        </div>
        <button onClick={()=>setShowDownload(true)} style={{ padding:"8px 16px",borderRadius:8,border:`0.5px solid ${gold}`,background:"transparent",color:gold,fontSize:13,cursor:"pointer",fontWeight:500,flexShrink:0 }}>Download ↓</button>
      </div>

      <div style={{ background:`${gold}10`,border:`0.5px solid ${gold}40`,borderRadius:12,padding:"16px 20px",marginBottom:24 }}>
        <p style={{ fontSize:13,fontWeight:500,color:gold,margin:"0 0 12px" }}>Your top 3 gifts</p>
        <div style={{ display:"flex",gap:10,flexWrap:"wrap" }}>
          {sorted.slice(0,3).map((g,i)=>(
            <div key={g.id} style={{ background:w.bg,border:`0.5px solid ${gold}40`,borderRadius:10,padding:"10px 16px",minWidth:140 }}>
              <div style={{ fontSize:11,color:w.text3,marginBottom:4 }}>#{i+1} · {g.category}</div>
              <div style={{ fontSize:15,fontWeight:500,color:w.text,marginBottom:4 }}>{g.name}</div>
              <div style={{ fontSize:20,fontWeight:500,color:gold }}>{g.score}<span style={{ fontSize:12,color:w.text3 }}>/{MAX_SCORE}</span></div>
            </div>
          ))}
        </div>
      </div>

      <h3 style={{ fontSize:14,fontWeight:500,color:w.text,margin:"0 0 12px" }}>Full ranked list</h3>
      {GIFT_CATEGORIES.map(cat=>(
        <div key={cat} style={{ marginBottom:20 }}>
          <p style={{ fontSize:12,fontWeight:500,color:w.text3,margin:"0 0 8px",textTransform:"uppercase",letterSpacing:"0.05em" }}>{cat}</p>
          {sorted.filter(g=>g.category===cat).map(g=>(
            <div key={g.id} style={{ background:w.bg,border:`0.5px solid ${w.border}`,borderRadius:10,marginBottom:8,overflow:"hidden" }}>
              <div onClick={()=>setExpanded(expanded===g.id?null:g.id)} style={{ display:"flex",alignItems:"center",gap:12,padding:"12px 16px",cursor:"pointer" }}>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:14,fontWeight:500,color:w.text,marginBottom:6 }}>{g.name}</div>
                  <div style={{ height:6,background:w.bg3,borderRadius:3,overflow:"hidden" }}><div style={{ height:"100%",width:`${g.pct}%`,background:scoreColor(g.pct),borderRadius:3 }} /></div>
                </div>
                <div style={{ textAlign:"right",minWidth:50 }}>
                  <div style={{ fontSize:18,fontWeight:500,color:scoreColor(g.pct) }}>{g.score}</div>
                  <div style={{ fontSize:11,color:w.text3 }}>/{MAX_SCORE}</div>
                </div>
                <div style={{ fontSize:12,color:w.text3 }}>{expanded===g.id?"▲":"▼"}</div>
              </div>
              {expanded===g.id&&(
                <div style={{ borderTop:`0.5px solid ${w.border}`,padding:"16px 20px",background:w.bg2 }}>
                  <p style={{ fontSize:13,color:w.text2,lineHeight:1.7,margin:"0 0 14px" }}>{g.description}</p>
                  <div style={{ marginBottom:12 }}>
                    <p style={{ fontSize:12,fontWeight:500,color:gold,margin:"0 0 6px" }}>Ministry roles</p>
                    <div style={{ display:"flex",gap:6,flexWrap:"wrap" }}>{g.ministryRoles.map(r=><span key={r} style={{ fontSize:11,padding:"3px 10px",background:w.bg,border:`0.5px solid ${w.border}`,borderRadius:20,color:w.text2 }}>{r}</span>)}</div>
                  </div>
                  <p style={{ fontSize:12,fontWeight:500,color:gold,margin:"0 0 6px" }}>How to grow</p>
                  <p style={{ fontSize:13,color:w.text2,lineHeight:1.7,margin:"0 0 8px" }}>{g.howToGrow}</p>
                  <p style={{ fontSize:11,color:w.text3,fontStyle:"italic" }}>{g.ref}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}

      <div style={{ display:"flex",gap:10,marginTop:8 }}>
        <button onClick={()=>setShowDownload(true)} style={{ flex:1,padding:"12px",borderRadius:10,border:`0.5px solid ${gold}`,background:"transparent",color:gold,fontSize:13,fontWeight:500,cursor:"pointer" }}>Download ↓</button>
        <button onClick={onRetake} style={{ flex:1,padding:"12px",borderRadius:10,border:`0.5px solid ${w.border}`,background:"transparent",color:w.text2,fontSize:13,cursor:"pointer" }}>Retake</button>
      </div>
    </div>
  );
}

function AssessmentView({ onComplete, onBack }) {
  const [giftIdx, setGiftIdx] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showIntro, setShowIntro] = useState(true);
  const gift=GIFTS[giftIdx];
  const totalQ=GIFTS.length*5;
  const answeredQ=Object.keys(answers).length;
  const progress=Math.round((answeredQ/totalQ)*100);
  const giftAnswers=gift.questions.map((_,qi)=>answers[`${gift.id}_${qi}`]);
  const allGiftAnswered=giftAnswers.every(a=>a!==undefined);
  const setAns=(qi,val)=>setAnswers(a=>({...a,[`${gift.id}_${qi}`]:val}));
  const finish=()=>{ const scores={};GIFTS.forEach(g=>{scores[g.id]=g.questions.reduce((sum,_,qi)=>sum+(answers[`${g.id}_${qi}`]||0),0);});onComplete({date:new Date().toISOString(),scores}); };
  const next=()=>{ if(giftIdx<GIFTS.length-1){setGiftIdx(i=>i+1);window.scrollTo(0,0);}else finish(); };

  if(showIntro) return (
    <div>
      <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",marginBottom:16,padding:0 }}>← Back</button>
      <h2 style={{ fontSize:18,fontWeight:500,margin:"0 0 8px",color:w.text }}>Spiritual Gifts Assessment</h2>
      <p style={{ fontSize:13,color:w.text2,lineHeight:1.7,margin:"0 0 16px" }}>This assessment covers <strong>{GIFTS.length} spiritual gifts</strong> across Romans 12, 1 Corinthians 12, and Ephesians 4. Rate each statement 1–5.</p>
      <Card style={{ background:`${gold}10`,border:`0.5px solid ${gold}30` }}><p style={{ fontSize:13,color:w.text2,lineHeight:1.7,margin:0 }}>Answer honestly based on your actual experience. There are no right or wrong answers. Estimated time: 20–30 minutes.</p></Card>
      <button onClick={()=>setShowIntro(false)} style={{ width:"100%",padding:"12px",borderRadius:10,border:"none",background:gold,color:"#fff",fontSize:14,fontWeight:500,cursor:"pointer",marginTop:16 }}>Start Assessment</button>
    </div>
  );

  return (
    <div>
      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8 }}>
        <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",padding:0 }}>← Back</button>
        <span style={{ fontSize:12,color:w.text3 }}>{answeredQ}/{totalQ} answered</span>
      </div>
      <div style={{ height:6,background:w.bg3,borderRadius:3,marginBottom:20,overflow:"hidden" }}><div style={{ height:"100%",width:`${progress}%`,background:gold,borderRadius:3,transition:"width 0.3s" }} /></div>
      <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:16 }}>
        <div style={{ width:10,height:10,borderRadius:"50%",background:gold,flexShrink:0 }} />
        <div>
          <p style={{ fontSize:11,color:w.text3,margin:0,textTransform:"uppercase",letterSpacing:"0.05em" }}>{gift.category} · Gift {giftIdx+1} of {GIFTS.length}</p>
          <h2 style={{ fontSize:18,fontWeight:500,margin:0,color:w.text }}>{gift.name}</h2>
        </div>
      </div>
      <p style={{ fontSize:13,color:w.text2,lineHeight:1.7,margin:"0 0 20px",fontStyle:"italic",borderLeft:`3px solid ${gold}`,paddingLeft:12 }}>{gift.description}</p>
      {gift.questions.map((q,qi)=>(
        <Card key={qi}>
          <p style={{ fontSize:13,color:w.text3,margin:"0 0 6px" }}>Statement {qi+1}</p>
          <p style={{ fontSize:14,color:w.text,lineHeight:1.6,margin:"0 0 14px" }}>{q}</p>
          <div style={{ display:"flex",gap:8 }}>
            {LABELS.map((l,val)=>(
              <button key={val} onClick={()=>setAns(qi,val+1)} style={{ flex:1,padding:"8px 4px",borderRadius:8,fontSize:11,cursor:"pointer",textAlign:"center",border:`0.5px solid ${giftAnswers[qi]===val+1?gold:w.border}`,background:giftAnswers[qi]===val+1?gold:"transparent",color:giftAnswers[qi]===val+1?"#fff":w.text3,fontWeight:giftAnswers[qi]===val+1?500:400 }}>
                <div style={{ fontSize:14,fontWeight:500,marginBottom:2 }}>{val+1}</div>
                <div style={{ fontSize:9 }}>{l}</div>
              </button>
            ))}
          </div>
        </Card>
      ))}
      <div style={{ display:"flex",gap:10,marginTop:8 }}>
        {giftIdx>0&&<button onClick={()=>{setGiftIdx(i=>i-1);window.scrollTo(0,0);}} style={{ flex:1,padding:"12px",borderRadius:10,border:`0.5px solid ${w.border}`,background:"transparent",color:w.text2,fontSize:14,cursor:"pointer" }}>← Previous</button>}
        <button onClick={next} disabled={!allGiftAnswered} style={{ flex:2,padding:"12px",borderRadius:10,border:"none",background:allGiftAnswered?gold:"#ccc",color:"#fff",fontSize:14,fontWeight:500,cursor:allGiftAnswered?"pointer":"not-allowed" }}>
          {giftIdx<GIFTS.length-1?`Next: ${GIFTS[giftIdx+1].name} →`:"See My Results"}
        </button>
      </div>
      <p style={{ fontSize:11,color:w.text3,textAlign:"center",marginTop:12 }}>Gift {giftIdx+1} of {GIFTS.length} — {GIFTS.length-giftIdx-1} remaining</p>
    </div>
  );
}

function HistoryView({ attempts, onSelect, onBack }) {
  return (
    <div>
      <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",marginBottom:16,padding:0 }}>← Back</button>
      <h2 style={{ fontSize:18,fontWeight:500,margin:"0 0 16px",color:w.text }}>Assessment History</h2>
      {[...attempts].reverse().map((a,i)=>{
        const sorted=Object.entries(a.scores).sort((x,y)=>y[1]-x[1]);
        const top3=sorted.slice(0,3).map(([id])=>GIFTS.find(g=>g.id===id)?.name).filter(Boolean);
        return (
          <div key={i} onClick={()=>onSelect(a)} style={{ background:w.bg,border:`0.5px solid ${w.border}`,borderRadius:12,padding:"16px 20px",marginBottom:10,cursor:"pointer" }}
            onMouseEnter={e=>e.currentTarget.style.borderColor=gold}
            onMouseLeave={e=>e.currentTarget.style.borderColor=w.border}>
            <div style={{ display:"flex",justifyContent:"space-between",marginBottom:8 }}>
              <span style={{ fontSize:14,fontWeight:500,color:w.text }}>{new Date(a.date).toLocaleDateString("en-IN",{day:"numeric",month:"long",year:"numeric"})}</span>
              <span style={{ fontSize:12,color:w.text3 }}>Attempt {attempts.length-i}</span>
            </div>
            <div style={{ display:"flex",gap:6,flexWrap:"wrap" }}>{top3.map(n=><span key={n} style={{ fontSize:11,padding:"3px 10px",background:`${gold}15`,color:gold,borderRadius:20 }}>{n}</span>)}</div>
          </div>
        );
      })}
    </div>
  );
}

export default function SpiritualGiftsModule({ moduleData, onSave, onBack, userName }) {
  const attempts=moduleData?.attempts||[];
  const [view, setView] = useState(attempts.length>0?"results":"intro");
  const [selected, setSelected] = useState(attempts.length>0?attempts[attempts.length-1]:null);
  const handleComplete=attempt=>{ const updated={attempts:[...attempts,attempt]};onSave(updated);setSelected(attempt);setView("results"); };

  if(view==="taking") return <AssessmentView onComplete={handleComplete} onBack={()=>setView(attempts.length>0?"results":"intro")} />;
  if(view==="results"&&selected) return <ResultsView attempt={selected} userName={userName||"User"} onRetake={()=>setView("taking")} onBack={onBack} />;
  if(view==="history") return <HistoryView attempts={attempts} onSelect={a=>{setSelected(a);setView("results");}} onBack={()=>setView("results")} />;

  return (
    <div>
      <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",marginBottom:16,padding:0 }}>← Back to Modules</button>
      <div style={{ display:"flex",alignItems:"center",gap:12,marginBottom:8 }}>
        <div style={{ width:40,height:40,borderRadius:10,background:`${gold}20`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20 }}>🎁</div>
        <div><h2 style={{ fontSize:18,fontWeight:500,margin:0,color:w.text }}>Spiritual Gifts Assessment</h2><p style={{ fontSize:13,color:w.text3,margin:0 }}>{GIFTS.length} gifts · Romans 12, 1 Cor 12, Eph 4</p></div>
      </div>
      <p style={{ fontSize:13,color:w.text2,lineHeight:1.7,margin:"16px 0 20px" }}>Discover how God has uniquely gifted you for His kingdom.</p>
      <button onClick={()=>setView("taking")} style={{ width:"100%",padding:"14px",borderRadius:10,border:"none",background:gold,color:"#fff",fontSize:15,fontWeight:500,cursor:"pointer",marginBottom:12 }}>Start Assessment</button>
      {attempts.length>0&&<button onClick={()=>setView("history")} style={{ width:"100%",padding:"12px",borderRadius:10,border:`0.5px solid ${w.border}`,background:"transparent",color:w.text2,fontSize:13,cursor:"pointer" }}>View History ({attempts.length} attempt{attempts.length!==1?"s":""})</button>}
    </div>
  );
}
